/**
 * "Real-world Process Simulation" — like the Connectivity illustration, the Figma
 * source (node 2252:52867) is a flat bitmap, so the artwork is re-traced into
 * vector and the parts that read as process are animated: the plant runs, the
 * substation switches, and a highlight runs the length of the train.
 *
 * Geometry is the traced 658x123 export, 1:1.
 */
const RealWorldArt = () => (
  <>
    <svg
      viewBox="0 0 658 123"
      fill="#F41E3D"
      role="img"
      aria-label="A water treatment plant, a power substation and a train"
      className="h-auto w-full"
    >
      <defs>
        {/* The highlight is painted through the train's own outline, so it only
            lands on the linework it passes over. */}
        <clipPath id="otRwTrainClip">
          <path d="M532.7 121.3C532.3 121 532.5 120.1 533.1 119.3C533.9 118.5 536.6 118 541 118L547.8 118L546.2 114.5C544.6 111 544.5 111 538.3 111L532 111L532 78.5L532 46L535 46C537.5 46 538 45.6 538 43.7C538 42.5 538.7 40.4 539.6 39.2C541 37.1 541.8 37 555.5 37C569.2 37 570 37.1 571.4 39.2C572.3 40.4 573 42.5 573 43.7C573 45.9 573.3 46 582.3 46C592.5 46 601.2 47.9 612 52.5C626.9 58.8 644 70.9 650.3 79.8C656.8 88.8 654.5 102.2 645.4 107.9L641.2 110.6L643.3 114.3C645.2 117.7 645.7 118 650.1 118C654.5 118 657.9 119.8 656.3 121.3C655.5 122.2 533.5 122.2 532.7 121.3Z M585.2 116.8C584.5 116.1 584 114.6 584 113.3C584 111.3 583.5 111 580 111C576.5 111 576 111.3 576 113.3C576 114.6 575.5 116.1 574.8 116.8C573.9 117.7 575 118 580 118C585 118 586.1 117.7 585.2 116.8Z M622.3 114.8C620.1 111 615.6 109.7 614.7 112.7C614.5 113.7 613.9 115.3 613.5 116.2C612.9 117.8 613.4 118 618.5 118L624.2 118L622.3 114.8Z M642 117.4C642 117.1 641.2 115.5 640.3 113.9C638.6 111.1 638.3 111 630.7 111L622.8 111L624.2 113.2C625 114.5 626 116.1 626.4 116.8C627.1 118 642 118.6 642 117.4Z M557.4 114.4C558.3 113.6 559 112.2 559 111.5C559 110.8 558.3 109.4 557.4 108.6C554.4 105.6 550 107.3 550 111.5C550 115.7 554.4 117.4 557.4 114.4Z M570.8 114.8C572.5 113.1 572.3 109.5 570.5 108C568.5 106.3 564.3 107.5 563.5 110C562.1 114.4 567.6 118 570.8 114.8Z M596 114.4C597 113.3 597.1 112.1 596.4 110.2C594.7 105.4 588 106.4 588 111.4C588 115.7 593.3 117.7 596 114.4Z M609.4 113.8C610.7 111.9 610.8 111.3 609.6 109.5C607.8 106.8 605.3 106.4 602.9 108.6C600.6 110.7 600.5 111.8 602.7 114.2C604.9 116.6 607.6 116.5 609.4 113.8Z M542 104C542.7 102.3 544.7 99.9 546.4 98.7C549.4 96.5 550 96.5 581.7 96.5C612.6 96.5 614 96.6 616.7 98.6C618.2 99.7 620.2 102.1 621 103.9L622.5 107.1L631.7 106.8C640.3 106.5 641.1 106.3 644.1 103.5C647 100.7 650 95.5 650 93C650 92.5 647.8 92 644.9 92L639.9 92L640.2 87.3C640.5 82.9 640.7 82.5 643.5 81.9L646.5 81.4L641.7 76.7L637 72L614.7 72L592.5 72L588.8 65.4C586.7 61.8 585 58.2 585 57.4C585 56.4 587.6 56 596.8 55.8L608.5 55.5L602 53.1C595.7 50.7 594.4 50.6 565.8 50.2L536 49.9L536 52.9L536 56L554.7 56.2L573.5 56.5L577.7 63.5C580 67.3 582 70.8 582 71.2C582 71.7 571.6 72 559 72L536 72L536 74.5L536 77L560 77L584 77L586 80.2C587.1 82 588 84.1 588 84.8C588 85.7 582.1 86 562 86L536 86L536 96.5C536 106.9 536 107 538.4 107C540.1 107 541.1 106.1 542 104Z M548.6 104.9C550.1 103.2 551.2 102.9 555 103.4C557.5 103.7 560.2 104 561 104C561.8 104 564.5 103.7 567 103.4C570.8 102.9 571.9 103.2 573.4 104.9C574.8 106.5 576.5 107 580 107C583.5 107 585.2 106.5 586.6 104.9C588.1 103.2 589.2 102.9 593 103.4C598.6 104.1 599.4 104.1 605 103.4C608.7 103 609.9 103.2 611.7 104.9C613.9 107 620 107.9 620 106.1C620 104 615.6 100 612.2 99C607.2 97.6 555 97.7 551.3 99.1C547.9 100.4 544 103.9 544 105.7C544 107.7 546.4 107.3 548.6 104.9Z M650 88.9C650 86.2 647.8 84 645 84C642.3 84 642 84.3 642 87C642 89.8 642.2 90 646 90C648.2 90 650 89.5 650 88.9Z M585 83.2C585 82.8 584.3 81.7 583.6 80.8C582.4 79.2 580 79 559.1 79L536 79L536 81.5L536 84L560.5 84C574 84 585 83.7 585 83.2Z M578 69.4C578 69 576.6 66.3 574.9 63.4L571.9 58L553.9 58L536 58L536 64L536 70L557 70C568.5 70 578 69.7 578 69.4Z M601.8 69.2C601.6 68.8 600.2 66.1 598.6 63.2C595.9 58.3 595.4 58 591.8 58C589.7 58 588 58.3 588 58.6C588 59 589.4 61.7 591.1 64.6C594 69.7 594.4 70 598.2 70C600.4 70 602 69.7 601.8 69.2Z M632.5 69.1C631.9 68.5 627.7 65.8 623.1 63.1C614.9 58.1 614.5 58 606.8 58C602.5 58 599 58.3 599 58.6C599 59 600.4 61.7 602.1 64.6L605.1 70L619.3 70C628.2 70 633 69.6 632.5 69.1Z M568.8 43.8C568.5 41.6 568.1 41.5 556.1 41.2C546.8 41 543.5 41.3 542.8 42.2C540.7 45.7 541.8 46 555.6 46C569.1 46 569.1 46 568.8 43.8Z" />
        </clipPath>
        <linearGradient id="otRwSweep" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0" />
          <stop offset="50%" stopColor="#ffffff" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>

      <path d="M0.7 121.3C-0.5 120.2 2.1 118 4.6 118L7 118L7 96L7 74L11.5 74L16 74L16.2 42.2L16.5 10.5L21.2 10.2C25.8 9.9 26 9.7 26 6.9C26 4 25.9 4 20.5 4C16.3 4 15 3.7 15 2.5C15 1.2 18.8 1 45.8 1.2C65.6 1.4 76.4 1.9 76.3 2.5C76.1 3 73.3 3.6 70 3.8C64.1 4.1 64 4.2 64 7C64 9.8 64.2 9.9 69.2 10.2L74.5 10.5L74.8 14.2L75.1 18L94.8 18C116.4 18 117.5 18.3 120.5 24C121.3 25.6 122 29.5 122 32.7C122 38.5 122 38.6 125.5 39.9C130 41.5 134 46.8 134.7 51.9C135.1 54.8 135.8 56 137.2 56.2C139.7 56.6 139.6 58.4 137 58.8C134.1 59.3 134.1 64.7 137 65.2C138.2 65.4 139.1 66 139.1 66.5C139.1 67 138.2 67.6 137 67.8C135.5 68.1 135 68.9 135 71.1C135 73.8 135.3 74 138.5 74L142 74L142 95.9L142 117.9L145.2 118.2C147.4 118.4 148.6 119.1 148.8 120.2C149.1 121.9 145.1 122 75.2 122C34.6 122 1 121.7 0.7 121.3Z M22 101.5L22 85L37 85L52 85L52 101.5L52 118L95 118L138 118L138 98.2L138 78.3L81.6 77.6C50.5 77.2 22 77.2 18.1 77.6L11 78.3L11 98.1L11 118L16.5 118L22 118L22 101.5Z M50 106.5L50 95L37 95L24 95L24 106.5L24 118L37 118L50 118L50 106.5Z M50 90L50 87L37 87L24 87L24 90L24 93L37 93L50 93L50 90Z M71 44.5L71 14L45.5 14L20 14L20 44.5L20 75L45.5 75L71 75L71 44.5Z M81 71C81 69 80.5 68 79.5 68C78.7 68 78 67.3 78 66.5C78 65.7 78.7 65 79.5 65C80.5 65 81 64 81 62.1C81 60.5 80.4 59 79.5 58.6C78.7 58.3 78 57.6 78 57C78 56.5 78.7 56 79.5 56C80.5 56 81 55 81 52.8C81 46.8 88 39 93.2 39C95.7 39 95.5 35.5 92.8 33C91 31.3 89.3 31 82.8 31L75 31L75 52.5L75 74L78 74C80.7 74 81 73.7 81 71Z M110 71L110 68L97 68L84 68L84 71L84 74L97 74L110 74L110 71Z M132 71L132 68L122.5 68L113 68L113 71L113 74L122.5 74L132 74L132 71Z M110 62L110 59L97 59L84 59L84 62L84 65L97 65L110 65L110 62Z M132 62L132 59L122.5 59L113 59L113 62L113 65L122.5 65L132 65L132 62Z M109.7 52.3C108.5 45.1 100.7 40.2 93.6 42.1C89.1 43.3 84 49.2 84 53L84 56L97.1 56L110.3 56L109.7 52.3Z M132 54C132 50.8 129.3 46.4 126 44C122.4 41.5 117.7 41.1 113.2 42.9C110.1 44.2 110.1 44.3 111.5 47.1C112.3 48.6 113 51.3 113 53L113 56L122.5 56C131.4 56 132 55.9 132 54Z M111 40.3C112.4 39.7 114.7 38.9 116.2 38.6C118.8 38 119 37.7 119 32.4C119 27.6 118.6 26.5 116.1 23.9L113.2 21L94.1 21L75 21L75 24.5L75 28L83.6 28C91.7 28 92.3 28.1 95.1 30.9C96.7 32.5 98 34.8 98 36C98 37.1 98.8 38.3 99.8 38.6C100.7 38.9 102.8 39.8 104.5 40.5C106.2 41.3 107.7 41.8 108 41.7C108.3 41.5 109.6 40.9 111 40.3Z M38 7C38 4.1 37.8 4 33.5 4C29.2 4 29 4.1 29 7C29 9.9 29.2 10 33.5 10C37.8 10 38 9.9 38 7Z M49 7C49 4.2 48.8 4 45 4C41.2 4 41 4.2 41 7C41 9.8 41.2 10 45 10C48.8 10 49 9.8 49 7Z M61 7C61 4.1 60.8 4 56.5 4C52.2 4 52 4.1 52 7C52 9.9 52.2 10 56.5 10C60.8 10 61 9.9 61 7Z M272.2 120.2C272.5 118.8 273.9 118.5 281.3 118.2L290 117.9L290 98.5L290 79L287.2 79C285.3 79 284.2 79.7 283.5 81.2C282 84.6 277.8 85.7 274.6 83.6C271 81.3 270.9 75.7 274.5 73.4L277 71.8L277 48.8L277 25.8L274.4 23.8C270.9 21 271.3 15.1 275.2 13.2C278.5 11.7 283 13.1 283.7 16C284.2 17.9 285.1 18 296.6 18C304.2 18 309 18.4 309 19C309 19.6 304.4 20 297.1 20L285.2 20L282.1 23.1L279 26.2L279 48.7L279 71.2L282.1 74.1C283.8 75.7 286.3 77 287.6 77C289.9 77 290 76.8 290 69L290 61L332 61L374 61L374 69C374 76.9 374 77 376.6 77C378.1 77 380.4 75.8 382.1 74.1L385 71.2L385 48.7L385 26.2L381.9 23.1L378.8 20L366.9 20C359.6 20 355 19.6 355 19C355 18.4 359.8 18 367.3 18C379.4 18 379.7 17.9 380.8 15.6C382.2 12.5 386.5 11.4 389.6 13.5C393 15.7 392.9 21.1 389.5 23.8L387 25.8L387 48.8L387 71.8L389.5 73.4C393 75.7 393 81.3 389.5 83.6C386.3 85.7 382.3 84.7 380.8 81.5C380 79.7 378.9 79 376.8 79L374 79L374 98.5L374 117.9L382.7 118.2C390.1 118.5 391.5 118.8 391.8 120.2C392.1 121.9 388.7 122 332 122C275.3 122 271.9 121.9 272.2 120.2Z M299 115.5C299 113.5 298.5 113 296.5 113C294.5 113 294 113.5 294 115.5C294 117.5 294.5 118 296.5 118C298.5 118 299 117.5 299 115.5Z M363 115.5L363 113L332 113L301 113L301 115.5L301 118L332 118L363 118L363 115.5Z M370 115.5C370 113.5 369.5 113 367.5 113C365.5 113 365 113.5 365 115.5C365 117.5 365.5 118 367.5 118C369.5 118 370 117.5 370 115.5Z M299 91.5L299 72L296.5 72L294 72L294 91.5L294 111L296.5 111L299 111L299 91.5Z M363 91.5L363 72L332 72L301 72L301 91.5L301 111L332 111L363 111L363 91.5Z M370 91.5L370 72L367.5 72L365 72L365 91.5L365 111L367.5 111L370 111L370 91.5Z M387.7 77.6C387.3 76.7 386.4 76.3 385.5 76.6C383.7 77.3 383.5 79.7 385.2 80.3C387 80.9 388.4 79.4 387.7 77.6Z M280 78.5C280 77.7 279.1 77 278 77C276.9 77 276 77.7 276 78.5C276 79.3 276.9 80 278 80C279.1 80 280 79.3 280 78.5Z M299 67.5C299 65.5 298.5 65 296.5 65C294.5 65 294 65.5 294 67.5C294 69.5 294.5 70 296.5 70C298.5 70 299 69.5 299 67.5Z M363 67.5L363 65L332 65L301 65L301 67.5L301 70L332 70L363 70L363 67.5Z M370 67.5C370 65.5 369.5 65 367.5 65C365.5 65 365 65.5 365 67.5C365 69.5 365.5 70 367.5 70C369.5 70 370 69.5 370 67.5Z M279.8 18.7C280 17.5 279.5 17 278.1 17C276.9 17 276 17.6 276 18.3C276 21.4 279.2 21.7 279.8 18.7Z M387.8 18.7C388 17.7 387.5 17 386.6 17C384.8 17 383.7 18.6 384.5 20.1C385.4 21.5 387.4 20.7 387.8 18.7Z" />
      <path
        className="ot-rw-window"
        style={{ animationDelay: "0.00s" }}
        d="M61.2 95.8L61.5 86.5L66.2 86.2L71 85.9L71 95.4L71 105L66 105L60.9 105L61.2 95.8Z M69 95.5L69 88L66 88L63 88L63 95.5L63 103L66 103L69 103L69 95.5Z"
      />
      <path
        className="ot-rw-window"
        style={{ animationDelay: "0.22s" }}
        d="M80 95.5L80 86L85 86L90 86L90 95.5L90 105L85 105L80 105L80 95.5Z M88 95.5L88 88L85 88L82 88L82 95.5L82 103L85 103L88 103L88 95.5Z"
      />
      <path
        className="ot-rw-window"
        style={{ animationDelay: "0.44s" }}
        d="M99 95.5L99 86L104 86L109 86L109 95.5L109 105L104 105L99 105L99 95.5Z M107 95.5L107 88L104 88L101 88L101 95.5L101 103L104 103L107 103L107 95.5Z"
      />
      <path
        className="ot-rw-window"
        style={{ animationDelay: "0.66s" }}
        d="M118 95.5L118 86L123 86L128 86L128 95.5L128 105L123 105L118 105L118 95.5Z M126 95.5L126 88L123 88L120 88L120 95.5L120 103L123 103L126 103L126 95.5Z"
      />
      <path
        className="ot-rw-drop"
        d="M36.3 55.5C32.8 52 32.7 51.8 33.2 45.6C33.9 36.8 41.7 22 45.5 22C47.6 22 53.6 30.5 56 36.8C57.1 39.7 58 44.4 58 47.1C58 51.6 57.6 52.6 54.6 55.6C51.5 58.7 50.6 59 45.5 59C40.3 59 39.5 58.7 36.3 55.5Z M51.4 52.9C55.8 49.4 54.8 42.2 48.4 31.2L45.8 26.8L43.2 30.6C39.9 35.5 37 43.2 37 47.1C37 53.9 45.7 57.4 51.4 52.9Z"
      />
      <path
        className="ot-rw-drop-hi"
        d="M39.6 49.4C38.7 47 38.9 43.3 40.2 40.5C41.6 37.4 43.5 37.2 42.5 40.2C41.1 44.9 40.8 47.8 41.9 48.4C43.5 49.4 43.3 51 41.6 51C40.8 51 39.9 50.3 39.6 49.4Z"
      />
      <path
        className="ot-rw-bolt"
        d="M323 52.6C323 51.3 323.9 45.8 325 40.5C326.1 35.2 327 30.4 327 29.9C327 29.4 324.1 29 320.5 29C315.6 29 314 28.7 314 27.6C314 25.7 322.1 2.8 323.3 1.3C323.9 0.4 327 0 332.2 0C338.5 0 340.2 0.3 340.7 1.6C341.2 2.9 339.5 9.9 337.3 15.8C336.9 16.7 338.5 17 343.4 17C349.1 17 350 17.2 350 18.8C350 20.6 327.8 52.8 325.6 54.2C323.7 55.5 323 55.1 323 52.6Z M336.9 31.5L344 21.5L338.4 21.2C335.3 21 332.7 20.4 332.4 19.7C332.2 19 333.1 15.2 334.4 11.2L336.9 4L331.5 4L326.2 4L322.7 14.5L319.1 25L324.5 25C331.5 25 332.2 26 330.5 34C329 41 328.8 42.6 329.4 41.9C329.7 41.7 333 37 336.9 31.5Z"
      />
      <path
        className="ot-rw-fin"
        style={{ animationDelay: "0.00s" }}
        d="M307 80.4C307 75.9 309.4 76.2 309.8 80.8C310 83.2 309.7 84 308.6 84C307.4 84 307 83 307 80.4Z M307.6 106.3C307.3 106 307 101.9 307 97.3C307 90.6 307.3 89 308.5 89C309.7 89 310 90.6 310 97.4C310 105.2 309.3 107.9 307.6 106.3Z"
      />
      <path
        className="ot-rw-fin"
        style={{ animationDelay: "0.12s" }}
        d="M319 80.5C319 78 319.4 77 320.2 77.2C320.9 77.5 321.5 78.9 321.5 80.5C321.5 82.1 320.9 83.5 320.2 83.8C319.4 84 319 83 319 80.5Z M319.6 106.3C319.3 106 319 101.9 319 97.3C319 90.6 319.3 89 320.5 89C321.7 89 322 90.6 322 97.4C322 105.2 321.3 107.9 319.6 106.3Z"
      />
      <path
        className="ot-rw-fin"
        style={{ animationDelay: "0.24s" }}
        d="M331 80.5C331 78 331.4 77 332.2 77.2C332.9 77.5 333.5 78.9 333.5 80.5C333.5 82.1 332.9 83.5 332.2 83.8C331.4 84 331 83 331 80.5Z M331 98C331 91.1 331.3 88.9 332.2 89.2C334 89.8 334 106.2 332.2 106.8C331.3 107.1 331 104.9 331 98Z"
      />
      <path
        className="ot-rw-fin"
        style={{ animationDelay: "0.36s" }}
        d="M343 80.5C343 78 343.4 77 344.2 77.2C344.9 77.5 345.5 78.9 345.5 80.5C345.5 82.1 344.9 83.5 344.2 83.8C343.4 84 343 83 343 80.5Z M343 98C343 91.1 343.3 88.9 344.2 89.2C346 89.8 346 106.2 344.2 106.8C343.3 107.1 343 104.9 343 98Z"
      />
      <path
        className="ot-rw-fin"
        style={{ animationDelay: "0.48s" }}
        d="M354.4 82.6C353.6 80.5 354.3 77.7 355.8 77.2C356.6 77 357 78 357 80.4C357 84 355.4 85.3 354.4 82.6Z M354.4 105.7C353.4 103 354.5 89.7 355.8 89.2C356.7 88.9 357 91.1 357 97.9C357 103.5 356.6 107 356 107C355.4 107 354.7 106.4 354.4 105.7Z"
      />
      <circle className="ot-rw-node" cx="278" cy="19.4" r="2" style={{ animationDelay: "0.00s" }} />
      <circle
        className="ot-rw-node"
        cx="385.9"
        cy="19.3"
        r="2"
        style={{ animationDelay: "0.20s" }}
      />
      <circle
        className="ot-rw-node"
        cx="385.9"
        cy="78.6"
        r="2"
        style={{ animationDelay: "0.40s" }}
      />
      <circle className="ot-rw-node" cx="278" cy="78.5" r="2" style={{ animationDelay: "0.60s" }} />

      <g className="ot-rw-train">
        <path d="M532.7 121.3C532.3 121 532.5 120.1 533.1 119.3C533.9 118.5 536.6 118 541 118L547.8 118L546.2 114.5C544.6 111 544.5 111 538.3 111L532 111L532 78.5L532 46L535 46C537.5 46 538 45.6 538 43.7C538 42.5 538.7 40.4 539.6 39.2C541 37.1 541.8 37 555.5 37C569.2 37 570 37.1 571.4 39.2C572.3 40.4 573 42.5 573 43.7C573 45.9 573.3 46 582.3 46C592.5 46 601.2 47.9 612 52.5C626.9 58.8 644 70.9 650.3 79.8C656.8 88.8 654.5 102.2 645.4 107.9L641.2 110.6L643.3 114.3C645.2 117.7 645.7 118 650.1 118C654.5 118 657.9 119.8 656.3 121.3C655.5 122.2 533.5 122.2 532.7 121.3Z M585.2 116.8C584.5 116.1 584 114.6 584 113.3C584 111.3 583.5 111 580 111C576.5 111 576 111.3 576 113.3C576 114.6 575.5 116.1 574.8 116.8C573.9 117.7 575 118 580 118C585 118 586.1 117.7 585.2 116.8Z M622.3 114.8C620.1 111 615.6 109.7 614.7 112.7C614.5 113.7 613.9 115.3 613.5 116.2C612.9 117.8 613.4 118 618.5 118L624.2 118L622.3 114.8Z M642 117.4C642 117.1 641.2 115.5 640.3 113.9C638.6 111.1 638.3 111 630.7 111L622.8 111L624.2 113.2C625 114.5 626 116.1 626.4 116.8C627.1 118 642 118.6 642 117.4Z M557.4 114.4C558.3 113.6 559 112.2 559 111.5C559 110.8 558.3 109.4 557.4 108.6C554.4 105.6 550 107.3 550 111.5C550 115.7 554.4 117.4 557.4 114.4Z M570.8 114.8C572.5 113.1 572.3 109.5 570.5 108C568.5 106.3 564.3 107.5 563.5 110C562.1 114.4 567.6 118 570.8 114.8Z M596 114.4C597 113.3 597.1 112.1 596.4 110.2C594.7 105.4 588 106.4 588 111.4C588 115.7 593.3 117.7 596 114.4Z M609.4 113.8C610.7 111.9 610.8 111.3 609.6 109.5C607.8 106.8 605.3 106.4 602.9 108.6C600.6 110.7 600.5 111.8 602.7 114.2C604.9 116.6 607.6 116.5 609.4 113.8Z M542 104C542.7 102.3 544.7 99.9 546.4 98.7C549.4 96.5 550 96.5 581.7 96.5C612.6 96.5 614 96.6 616.7 98.6C618.2 99.7 620.2 102.1 621 103.9L622.5 107.1L631.7 106.8C640.3 106.5 641.1 106.3 644.1 103.5C647 100.7 650 95.5 650 93C650 92.5 647.8 92 644.9 92L639.9 92L640.2 87.3C640.5 82.9 640.7 82.5 643.5 81.9L646.5 81.4L641.7 76.7L637 72L614.7 72L592.5 72L588.8 65.4C586.7 61.8 585 58.2 585 57.4C585 56.4 587.6 56 596.8 55.8L608.5 55.5L602 53.1C595.7 50.7 594.4 50.6 565.8 50.2L536 49.9L536 52.9L536 56L554.7 56.2L573.5 56.5L577.7 63.5C580 67.3 582 70.8 582 71.2C582 71.7 571.6 72 559 72L536 72L536 74.5L536 77L560 77L584 77L586 80.2C587.1 82 588 84.1 588 84.8C588 85.7 582.1 86 562 86L536 86L536 96.5C536 106.9 536 107 538.4 107C540.1 107 541.1 106.1 542 104Z M548.6 104.9C550.1 103.2 551.2 102.9 555 103.4C557.5 103.7 560.2 104 561 104C561.8 104 564.5 103.7 567 103.4C570.8 102.9 571.9 103.2 573.4 104.9C574.8 106.5 576.5 107 580 107C583.5 107 585.2 106.5 586.6 104.9C588.1 103.2 589.2 102.9 593 103.4C598.6 104.1 599.4 104.1 605 103.4C608.7 103 609.9 103.2 611.7 104.9C613.9 107 620 107.9 620 106.1C620 104 615.6 100 612.2 99C607.2 97.6 555 97.7 551.3 99.1C547.9 100.4 544 103.9 544 105.7C544 107.7 546.4 107.3 548.6 104.9Z M650 88.9C650 86.2 647.8 84 645 84C642.3 84 642 84.3 642 87C642 89.8 642.2 90 646 90C648.2 90 650 89.5 650 88.9Z M585 83.2C585 82.8 584.3 81.7 583.6 80.8C582.4 79.2 580 79 559.1 79L536 79L536 81.5L536 84L560.5 84C574 84 585 83.7 585 83.2Z M578 69.4C578 69 576.6 66.3 574.9 63.4L571.9 58L553.9 58L536 58L536 64L536 70L557 70C568.5 70 578 69.7 578 69.4Z M601.8 69.2C601.6 68.8 600.2 66.1 598.6 63.2C595.9 58.3 595.4 58 591.8 58C589.7 58 588 58.3 588 58.6C588 59 589.4 61.7 591.1 64.6C594 69.7 594.4 70 598.2 70C600.4 70 602 69.7 601.8 69.2Z M632.5 69.1C631.9 68.5 627.7 65.8 623.1 63.1C614.9 58.1 614.5 58 606.8 58C602.5 58 599 58.3 599 58.6C599 59 600.4 61.7 602.1 64.6L605.1 70L619.3 70C628.2 70 633 69.6 632.5 69.1Z M568.8 43.8C568.5 41.6 568.1 41.5 556.1 41.2C546.8 41 543.5 41.3 542.8 42.2C540.7 45.7 541.8 46 555.6 46C569.1 46 569.1 46 568.8 43.8Z" />
        <g clipPath="url(#otRwTrainClip)">
          <rect
            className="ot-rw-shine"
            x="470"
            y="30"
            width="55"
            height="100"
            fill="url(#otRwSweep)"
          />
        </g>
      </g>
    </svg>

    <style jsx>{`
      /* Plant floor lights come up one window at a time. */
      @keyframes otRwWindow {
        0%,
        100% {
          opacity: 0.6;
        }
        40% {
          opacity: 1;
        }
      }
      :global(.ot-rw-window) {
        animation: otRwWindow 2.6s ease-in-out infinite;
      }

      /* Water in the tank swells; its inner highlight trails the same beat. */
      @keyframes otRwDrop {
        0%,
        100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.06);
        }
      }
      @keyframes otRwDropHi {
        0%,
        100% {
          opacity: 0.6;
        }
        50% {
          opacity: 1;
        }
      }
      :global(.ot-rw-drop) {
        transform-box: fill-box;
        transform-origin: center;
        animation: otRwDrop 3s ease-in-out infinite;
      }
      :global(.ot-rw-drop-hi) {
        animation: otRwDropHi 3s ease-in-out infinite 0.3s;
      }

      /* The bolt strikes twice, then rests — a steady flicker reads as neon. */
      @keyframes otRwBolt {
        0% {
          opacity: 0.75;
        }
        6% {
          opacity: 1;
        }
        12% {
          opacity: 0.8;
        }
        18% {
          opacity: 1;
        }
        28%,
        100% {
          opacity: 0.75;
        }
      }
      :global(.ot-rw-bolt) {
        animation: otRwBolt 2.8s linear infinite;
      }

      /* Current passes through the transformer coils, left to right. */
      @keyframes otRwFin {
        0%,
        100% {
          opacity: 0.7;
        }
        35% {
          opacity: 1;
        }
      }
      :global(.ot-rw-fin) {
        animation: otRwFin 1.8s ease-in-out infinite;
      }

      /* Terminals switch in sequence around the yard. */
      @keyframes otRwNode {
        0%,
        65%,
        100% {
          opacity: 0;
        }
        12%,
        40% {
          opacity: 1;
        }
      }
      :global(.ot-rw-node) {
        opacity: 0;
        animation: otRwNode 2s ease-in-out infinite;
      }

      /* Train: a highlight runs nose to tail while the body floats, so the
         bitmap-flat side view reads as moving. Both live on the same group so
         the highlight never drifts off the linework. */
      @keyframes otRwShine {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(270px);
        }
      }
      @keyframes otRwFloat {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-1.5px);
        }
      }
      :global(.ot-rw-shine) {
        animation: otRwShine 3.2s ease-in-out infinite;
      }
      :global(.ot-rw-train) {
        animation: otRwFloat 3.2s ease-in-out infinite;
      }

      @media (prefers-reduced-motion: reduce) {
        :global(.ot-rw-window),
        :global(.ot-rw-drop),
        :global(.ot-rw-drop-hi),
        :global(.ot-rw-bolt),
        :global(.ot-rw-fin),
        :global(.ot-rw-train) {
          animation: none;
        }
        :global(.ot-rw-node) {
          animation: none;
          opacity: 0;
        }
        :global(.ot-rw-shine) {
          animation: none;
          opacity: 0;
        }
      }
    `}</style>
  </>
);

export default RealWorldArt;
